import { InputNumberProps } from 'antd'

// 整数
const onlyIntegerConstraint: InputNumberProps = {
  precision: 0,
}

const float2Constraint: InputNumberProps = {
  precision: 2,
}
const float3Constraint: InputNumberProps = {
  precision: 3,
}

const greaterThenZero: InputNumberProps = {
  min: 0,
}

export const Constraint = {
  onlyIntegerConstraint,
  float2Constraint,
  float3Constraint,
  greaterThenZero,
}

export const onlyIntegerCustomProps = {
  customProps: {
    InputProps: {
      ...Constraint.onlyIntegerConstraint,
    },
  },
}
export const float2CustomProps = {
  customProps: {
    InputProps: {
      ...Constraint.float2Constraint,
    },
  },
}
export const float3CustomProps = {
  customProps: {
    InputProps: {
      ...Constraint.float3Constraint,
    },
  },
}
export const greaterThenZeroProps = {
  customProps: {
    InputProps: {
      ...Constraint.onlyIntegerConstraint,
      ...Constraint.greaterThenZero,
    },
  },
}

export const purchaseManProps = {
  customProps: {
    InputProps: {
      placeholder: '多个采购员之间英文逗号隔开',
    },
  },
}

export const notifiedPersonsProps = {
  customProps: {
    InputProps: {
      placeholder: '多个负责人之间英文逗号隔开',
    },
  },
}

export const createManNamesProps = {
  customProps: {
    InputProps: {
      placeholder: '多个创建人之间英文逗号隔开',
    },
  },
}

export const reviewersProps = {
  customProps: {
    InputProps: {
      placeholder: '多个审核人之间英文逗号隔开',
    },
  },
}

export const invoiceNumProps = {
  customProps: {
    InputProps: {
      placeholder: '多个发票号之间英文逗号隔开',
    },
  },
}
export const purchaseOrderNoProps = {
  customProps: {
    InputProps: {
      placeholder: '多个采购订单号之间英文逗号隔开',
    },
  },
}
export const onlyIntegerInputNumberCustomProps = {
  customProps: {
    InputNumberProps: {
      ...Constraint.onlyIntegerConstraint,
    },
  },
}
import { InputNumberProps } from 'antd'

// 整数
const onlyIntegerConstraint: InputNumberProps = {
  precision: 0,
}

const float2Constraint: InputNumberProps = {
  precision: 2,
}
const float3Constraint: InputNumberProps = {
  precision: 3,
}

const greaterThenZero: InputNumberProps = {
  min: 0,
}

export const Constraint = {
  onlyIntegerConstraint,
  float2Constraint,
  float3Constraint,
  greaterThenZero,
}

export const onlyIntegerCustomProps = {
  customProps: {
    InputProps: {
      ...Constraint.onlyIntegerConstraint,
    },
  },
}
export const float2CustomProps = {
  customProps: {
    InputProps: {
      ...Constraint.float2Constraint,
    },
  },
}
export const float3CustomProps = {
  customProps: {
    InputProps: {
      ...Constraint.float3Constraint,
    },
  },
}
export const greaterThenZeroProps = {
  customProps: {
    InputProps: {
      ...Constraint.onlyIntegerConstraint,
      ...Constraint.greaterThenZero,
    },
  },
}

export const purchaseManProps = {
  customProps: {
    InputProps: {
      placeholder: '多个采购员之间英文逗号隔开',
    },
  },
}

export const notifiedPersonsProps = {
  customProps: {
    InputProps: {
      placeholder: '多个负责人之间英文逗号隔开',
    },
  },
}

export const createManNamesProps = {
  customProps: {
    InputProps: {
      placeholder: '多个创建人之间英文逗号隔开',
    },
  },
}

export const reviewersProps = {
  customProps: {
    InputProps: {
      placeholder: '多个审核人之间英文逗号隔开',
    },
  },
}

export const invoiceNumProps = {
  customProps: {
    InputProps: {
      placeholder: '多个发票号之间英文逗号隔开',
    },
  },
}
export const purchaseOrderNoProps = {
  customProps: {
    InputProps: {
      placeholder: '多个采购订单号之间英文逗号隔开',
    },
  },
}
export const onlyIntegerInputNumberCustomProps = {
  customProps: {
    InputNumberProps: {
      ...Constraint.onlyIntegerConstraint,
    },
  },
}
